import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LogisticsService } from 'src/app/Services/Logistics/logistics.service'
import { DatePipe } from '@angular/common'
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { colors } from 'src/utils/colors';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { AsYouType } from 'libphonenumber-js'
//import { Script } from 'vm';


import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns';

interface Schedules {
  fullName: string;
  timeIn: string;
  pid:string;
  phoneNumber:string;
  branch:string;
  salesRep:string;
   
 }


@Component({
  selector: 'app-create-logistics-schedules',
  templateUrl: './create-logistics-schedules.component.html',
  styleUrls: ['./create-logistics-schedules.component.css']
})
export class CreateLogisticsSchedulesComponent implements OnInit {


    
 //_url= 'http://multiinspectionreport.com/reception/api';
 //_url= 'https://test.appointele.com/api';
 //_url= 'https://demo.appointele.com/api';
//_url= 'https://ciot.appointele.com/api';
_url= 'https://ciot.appointele.ca/api';

 
 color;
  events: any;
  items: Array<CalendarEvent<{ time: any }>> = [];
  viewDate: Date = new Date();
  view: CalendarView = CalendarView.Month;
  events$: Observable<CalendarEvent<{ schedules: Schedules }>[]>;
  activeDayIsOpen: boolean = false;

  alltodaysappointment=[];

branch;

  branchselected=false;
  salesRep=[];
loading=false;
questionaireForm:FormGroup;
date;
error:any = '';
success = '';
branchs;
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;
currentUser:User;
role;
username;

validationMessages = {
  'fullName': {
    'required': 'Full Name is required'
  },
  'phoneNumber': {
    'required': 'Phone Number is required'
  },

  'email': {
    'required': 'Email is required',
    'pattern' : 'Please enter a valid email'
  },

 'LookingFor': {
  'required': 'required'
},
'describesYouk': {
  'required': 'required'
},
'ageGroup': {
  'required': 'required'
},
'branch': {
  'required': 'Branch is required'
},
//'whatLoveProduct': {
 // 'required': 'required'
//},
'status': {
  'required': 'required'
}

};


formErrors = {
  'fullName': '',
  'phoneNumber': '',
  'email': '',
  'lookingFor': '',
  'describesYou': '',
  'ageGroup': '',
  'branch': '',
  'status': '',
}

asYouType: any;
format: any;
parse: any;

  constructor(private fb: FormBuilder,
    private router: Router,
    private _location: Location,
    private _http: HttpClient,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private _logistics: LogisticsService,
    public datepipe: DatePipe) {

      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.role=this.currentUser.role;


  
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }
      
      }

  ngOnInit(): void {


    this.fetchEvents();

    this.getAllBranchs();
  
    this.questionaireForm = this.fb.group({
      pid: new FormControl(''),
       fullName: new FormControl('', [Validators.required]),
       phoneNumber: new FormControl('',[Validators.required]),
       email: new FormControl(''),
       branch: new FormControl('',[Validators.required]),
       salesRep: new FormControl(''),
       requestType: new FormControl(''),
       invoiceNumber: new FormControl(''),
       status: new FormControl(''),
       pickupTime: new FormControl(''),
       checkOut: new FormControl(''),
       orderDescription: new FormControl(''),
       notes: new FormControl(''),
  
       
     });
  
  
     
//patching user's branch as a default branch for form
 /**  this.questionaireForm.patchValue({
    // departmentId: assetformmodel[0].department,
     branch: this.branch,
   });
   this.branchselected=true;
   this.getSalesRep(this.branch);
  **/
     /**this.questionaireForm.get('phoneNumber').valueChanges.subscribe(val => {
      var number = val;
      console.log(number)
      
      this.asYouType = new AsYouType('US').input(number)
        // this.branchselected = true;
     //  /   this. getSalesRep(this.userappointment[0].branch);
         this.questionaireForm.patchValue({
           phoneNumber:this.asYouType
         })
        })**/
  
  
     //error handling
     this.questionaireForm.valueChanges.subscribe((data) => {
       this.logValidationErrors(this.questionaireForm);
     })



    }





  
onSubmit(){
  this.logValidationErrors(this.questionaireForm );
 

  //this.questionaireForm.patchValue({
    //covid: covid});
  //const categoryselect=this.questionaireForm.get('category').value;
 // if(categoryselect==="Machinery" || categoryselect==="Laptops" || categoryselect==="Desktops" || categoryselect==="Printer");

 //console.log(this.questionaireForm.value);
       this._logistics.insertNewScheduleByReception(this.questionaireForm.value)
    .subscribe(//subscribe to Observable
      response => {console.log('Success!', response);
      this.success=response['SUCCESS'];
      this.questionaireForm.reset;        
      document.getElementById("openSuccessModalButton").click();
    },
      error => {console.error('Error!', error);
      this.error=error.error.text ;
    }       
    );

        }



  getAllBranchs(){
    this._logistics.getAllBranchs().subscribe(
      (res) => {
  
        this.branchs = res;
      },
      (err) => {
        this.error = err;
      }
    );
  }
  
  
  
  
  getSalesRep(branch){
   // console.log(branch);
    if (branch != "None" || branch!="") {
      this._logistics.getSalesRepByBranch(branch).subscribe(
        (res) => {
          this.salesRep = res;
        //  console.log(this.salesRep);
          this.branchselected = true;
   
        }
        ,
        (err) => {
          this.error = err;
        }
      );
    }
    else {
      this.branchselected = true;
    }
  
  
  
  }



  

patchPickupTime(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

  this.questionaireForm.patchValue({
    pickupTime:latest_date
  });
}



patchCheckOut(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

  this.questionaireForm.patchValue({
    checkOut:latest_date
  });
}


  
backClicked() {
  this._location.back();
}






logValidationErrors(group: FormGroup ): void {
  //get the keys from FormGroup object and checks all the keys
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } else {
      //clear any previous error
      this.formErrors[key] = '';
      //check Validation of the formControl
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        //if not valid then get the error message of whatever the validation error is from the validationMessage method
        const messages = this.validationMessages[key];
        //for every error in validation get the error key and assign it to the formControl name is formError method
        for (const errorkey in abstractControl.errors) {
          if (errorkey) {
      //      console.log(key);

            this.formErrors[key] += messages[errorkey] + ''
          }
        }
      }
    }

  });
}



 /************************************************************************************************************************** */
  //Calendar
  /**************************************************************************************************************************** */
  fetchEvents(): void {

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay,
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay,
    }[this.view];

  this.events$ = this._http.get(`${this._url}/active_all_appointment_for_branch_get.php?branch=${this.branch}`)
  .pipe(
    map(({ results }: { results: Schedules[] }) => {
      console.log(results);
      return results.map((schedules: Schedules) => {
        //this.colorForRep(schedules.salesRep);
     /**   if(appointment.salesRep=='Nicolas Salazar'){
          this.color=colors.blue;
        }else if(appointment.salesRep=='Tom Kizito'){
          this.color=colors.yellow;
        }**/
        return {
         
          title: schedules.fullName+' - '+(new Date(schedules.timeIn).toLocaleTimeString()).replace(/:\d+ /, ' ')+' - '+schedules.salesRep,
          start: new Date(
            schedules.timeIn
          ),
          
          color:this.color,
         // cssClass: main-dashboard.component.css,
          meta: {
            schedules,
          },

        };
      });
    })
  );


}


dayClicked({
  date,
  events,
}: {
  date: Date;
  events: CalendarEvent<{ schedules: Schedules }>[];
}): void {
  if (isSameMonth(date, this.viewDate)) {
    if (
      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
      events.length === 0
    ) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = true;
      this.viewDate = date;
    }
  }

}



eventClicked(event: CalendarEvent<{ schedules: Schedules }>): void {
  /**window.open(
    `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
    '_blank'
  );**/

  console.log(event.meta.schedules);
  if(event.meta.schedules.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:event.meta.schedules.pid,extra1:event.meta.schedules.timeIn,extra2:event.meta.schedules.salesRep,extra3:event.meta.schedules.branch}],{relativeTo:this.actroute});
  }else{
 
  this.router.navigate(['../appointment-details', { extra:event.meta.schedules.pid, extra1: event.meta.schedules.fullName,extra2:event.meta.schedules.phoneNumber,extra3:event.meta.schedules.branch }], { relativeTo: this.actroute });
}
}


}
